import { API_ENDPOINTS } from "../../config";
import { apiGET } from "../../hooks/APIHook";
import { css, routes } from "../config";

export const AdminNavigation = ({ route, setRoute }) => {
  const logout = () => {
    apiGET(API_ENDPOINTS.auth.logout).then((result) => {
      window.document.location = "/";
    });
  };

  return (
    <nav className={css("navbar navbar-dark bg-primary navbar-expand-lg")}>
      <div className={css("container-fluid")}>
        <a className={css("navbar-brand")} href="#f">
          SKT ylläpito
        </a>
        <button
          className={css("navbar-toggler")}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className={css("navbar-toggler-icon")}></span>
        </button>
        <div
          className={css("collapse navbar-collapse")}
          id="navbarSupportedContent"
        >
          <ul className={css("navbar-nav me-auto mb-2 mb-lg-0")}>
            {routes.map((t) => {
              return (
                <li className={css("nav-item")}>
                  <a
                    className={css("nav-link" + (t === route ? " active" : ""))}
                    aria-current="page"
                    href="#f"
                    onClick={() => setRoute(t)}
                  >
                    {t}
                  </a>
                </li>
              );
            })}
            <li className={css("nav-item")}>
              <a
                className={css("nav-link")}
                aria-current="page"
                href="#f"
                onClick={logout}
              >
                Kirjaudu ulos
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
